import { Col, Container, Row } from "reactstrap";
import React, { useState } from "react";
import HeaderComponent from "./HeaderComponent/HeaderComponent";
import wecover2 from "./0000-min.png";
import Button from "../../shared/Button/Button";
import mena from "./mena1.png";
import Editor from "./Editor/Editor";
import { Card, CardText, CardBody, CardFooter, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";
import meeting from "./meeting.png";
import "./AnnualSummitPageComponent.css";
import BuyTicketModalComponent from "./BuyTicketModalComponent/BuyTicketModalComponent";
function s3_map(str) {
  str = str?.replace("cebc2", "cebc3");
  str = str?.replace("cebc.s3.eu-central", "cebc3.s3.eu-central");
  return str;
}

function create_staff_view(staff) {
  const staff_view_array = staff?.map((member, index) => {
    return (
      <Col className="board_col my-2 mx-lg-2" md={4} lg={3} style={{}}>
        <div
          className="board_div mb-2 d-flex justify-content-stretch"
          style={{
            borderStyle: "none",
            backgroundColor: "",
            height: "100%",
            marginBottom: "30px !important",
          }}
        >
          <Card
            style={{
              height: "100%",
              width: "90%",
              maxWidth: "250px",
              boxShadow: "1px 3px 6px 1px #80808042",
            }}
          >
            <div
              className="card_title_container"
              style={{
                padding: "10px",
                fontWeight: "bold",
                height: "60px",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
              tag="h5"
            >
              {member.name}
            </div>
            <div className="card_image_container" style={{ height: "200px" }}>
              <img
                src={s3_map(
                  member.image
                    ? member.image.url
                    : "/assets/images/logo_black.png"
                )}
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                }}
                alt=""
              />
            </div>
            <CardBody
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "5px",
              }}
            >
              <CardText>{member.position}</CardText>
            </CardBody>

            {/* <CardFooter style={{ padding: "5px" }}>
              <div className="linkedin" style={{ fontSize: "18px" }}>
                <a href={member?.Linkedin_url ?? "#"}>
                  <i className="fab fa-linkedin i_link" aria-hidden="true"></i>
                </a>
              </div>
            </CardFooter> */}
          </Card>
        </div>
      </Col>
    );
  });
  return staff_view_array;
}

function create_agenda_topics_view(agenda_topics) {
  return agenda_topics?.map((topic) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          borderLeft: "solid 4px black",
          paddingLeft: "30px",
          backgroundColor: "white",
          marginBottom: "20px",
          padding: "20px",
        }}
      >
        <div style={{ textAlign: "start", color: "grey", fontSize: "22px" }}>
          {topic.time}
        </div>
        <div
          style={{
            textAlign: "start",
            fontSize: "22px",
            fontWeight: "bold",
            fontFamily: "Raleway",
          }}
        >
          {topic.topic}
        </div>
      </div>
    );
  });
}
function create_agenda_topics_view2(agenda_topics) {
  return agenda_topics?.map((topic) => {
    return (
      <tr className="summit-tr">
        <td className="summit-td first-col">
          <div
            className="mt-2"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
            }}
          >
            {" "}
            {topic?.time ?? "--"}
          </div>
        </td>
        <td className="summit-td">
          <div>
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                fontFamily: "Raleway",
              }}
            >
              {topic?.topic}
            </div>
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                fontFamily: "Raleway",
                color: "grey",
                marginBottom: "10px",
              }}
            >
              {topic?.description}
            </div>
          </div>
        </td>
      </tr>
    );
  });
}

function ConsultancyPageComponent(props) {
  const [TicketModalIsOpen, setTicketModalIsOpen] = useState(false);
  function toggle_Ticket_modal() {
    console.log("TicketModalIsOpen :>> ", TicketModalIsOpen);
    setTicketModalIsOpen((state) => !state);
  }

  function generate_sponsors_views(sponsors, type) {
    const members_views = sponsors?.map((member, index) => {
      if (member.type === type) {
        return (
          // <Link className="" to={member?.link ?? "#"}>
          <div class="member_card">
            {member.logo_image ? (
              <div class="member_card_sub_div2">
                <img
                  class="mem_carousel_img"
                  src={s3_map(member.logo_image && member.logo_image.url)}
                  alt="member"
                />
              </div>
            ) : (
              <div class="member_card_sub_div2 mem_carousel_sub_elem_text">
                <div class="mem_carousel_name">{member.name}</div>
              </div>
            )}
          </div>
          // </Link>
        );
      }
    });
    return members_views;
  }

  console.log("props", props);
  const data = props?.data;
  return (
    <div>
      <BuyTicketModalComponent
        toggle={toggle_Ticket_modal}
        ModalIsOpen={TicketModalIsOpen}
      />
      <HeaderComponent
        image={wecover2}
        date={data.date}
        title={data.title}
        address={data.address}
      ></HeaderComponent>
      <Container className="my-5">
        <Row>
          <Col md="4">
            <div onClick={toggle_Ticket_modal}>
              <Button
                text={"BUY A TICKET!"}
                icon={
                  <i
                    style={{ fontSize: "25px" }}
                    class="far fa-arrow-alt-circle-right mt-2"
                  ></i>
                }
              />
            </div>
          </Col>
          <Col md="4">
            <div>
              <a
                href={data?.sponsor_document?.url}
                download
                target="_blank"
                rel="noreferrer"
              >
                <Button
                  text={"SPONSOR THE EVENT"}
                  icon={
                    <i
                      style={{ fontSize: "25px" }}
                      class="far fa-arrow-alt-circle-right mt-2"
                    ></i>
                  }
                />
              </a>
            </div>
          </Col>
          <Col md="4">
            <div>
              <a
                href={data?.agenda_document?.url}
                download
                target="_blank"
                rel="noreferrer"
              >
                <Button
                  text={"DOWNLOAD AGENDA"}
                  icon={
                    <i
                      style={{ fontSize: "25px" }}
                      class="far fa-arrow-alt-circle-right mt-2"
                    ></i>
                  }
                />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
      <div
        style={{
          marginTop: "  0px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // backgroundColor: '#f7f7f7',
          height: "",
          paddingTop: "1px",
        }}
      >
        <Container>
          <Row className="title_row">
            <div className="section_header section_header_side">
              <span className="section_header_inner">ABOUT THE SUMMIT</span>
              <div className="section_header_under"></div>
            </div>
          </Row>
          <Row>
            <Col
              style={{
                fontFamily: "'Raleway', sans-serif",
                textAlign: "left",
                marginBottom: "40px",
                fontSize: "18px",
                paddingTop: "0px",
              }}
            >
              <div
                style={{ whiteSpace: "pre-wrap" }}
              >{`${data?.about_the_summit_paragraph}`}</div>
            </Col>
          </Row>
        </Container>
      </div>
      <Container className="mb-5">
        <Row className="title_row">
          <div className="section_header section_header_side">
            <span className="section_header_inner">Why Attend?</span>
            <div className="section_header_under"></div>
          </div>
        </Row>
        <Row style={{ position: "relative", top: "", overflow: "visible" }}>
          <div
            class="mena_image"
            style={{
              width: "125%",
              height: "500px",
              position: "absolute",
              top: "",
              left: "-15%",
              overflow: "visible",
              display: "flex",
              justifyContent: "center",
              margin: "auto",
            }}
          >
            <img
              src={mena}
              alt=""
              style={{
                margin: "auto",
                width: "95vw",
                height: "auto",
                filter: " grayscale(1)",
                opacity: " .1",
              }}
            />
          </div>

          {data?.why_attend_cards?.map((item) => {
            return (
              <Col className="p-md-2" md={{ size: 6 }}>
                <div className="media  media_element">
                  <div className="vision_icon" style={{}}>
                    <i className="solid  fas fa-lightbulb"></i>
                  </div>
                  <div className="media-body align-content-center text-left">
                    <h3
                      className="mt-0 media_header"
                      style={{ fontFamily: "Raleway" }}
                    >
                      {item.title}
                    </h3>
                    <div style={{ fontFamily: "Raleway" }}>{item.content}</div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>

        <Row className="justify-content-center">
          <Col md="4">
            <div onClick={toggle_Ticket_modal}>
              <Button
                text={"BUY A TICKET!"}
                icon={
                  <i
                    style={{ fontSize: "25px" }}
                    class="far fa-arrow-alt-circle-right mt-2"
                  ></i>
                }
              />
            </div>
          </Col>
        </Row>
      </Container>

      <Container
        style={{
          zIndex: "2",
          position: "relative",
          marginTop: "100px",
          marginBottom: "50px",
        }}
      >
        <Row className="">
          <div className="section_header section_header_side">
            <span className="section_header_inner">Become a Sponsor</span>
            <div className="section_header_under"></div>
          </div>
        </Row>

        <Row>
          {data?.become_a_sponsor_points?.map((point) => (
            <Col md={6}>
              <div
                className="join_card "
                style={{ backgroundColor: "#23693D", color: "white" }}
              >
                <div
                  className="header_text"
                  style={{
                    fontWeight: "bold",
                    fontSize: "22px",
                    minHeight: "70px",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    color: "white",
                  }}
                >
                  {point.text}
                </div>
              </div>
            </Col>
          ))}
        </Row>
        <Row className="justify-content-center mt-4">
          <Col md="4">
            <a
              href={data?.sponsor_document?.url}
              download
              target="_blank"
              rel="noreferrer"
            >
              <Button
                text={"SPONSOR THE EVENT"}
                icon={
                  <i
                    style={{ fontSize: "25px" }}
                    class="far fa-arrow-alt-circle-right mt-2"
                  ></i>
                }
              />
            </a>
          </Col>
        </Row>
      </Container>

      <Container
        fluid
        style={{
          zIndex: "2",
          position: "relative",
          marginTop: "0px",
          marginBottom: "50px",
          backgroundColor: "#F2F2F2",
          paddingBottom: "40px",
        }}
      >
        <Container style={{ paddingTop: "30px" }}>
          <Row className="title_row">
            <div className="section_header section_header_side">
              <span className="section_header_inner">Agenda Highlights</span>
              <div className="section_header_under"></div>
            </div>
          </Row>

          <div
            style={{
              width: "100%",
              margin: "auto",
            }}
          >
            <table className="summit-table">
              <tr className="summit-tr">
                <th className="summit-th first-col">
                  <div>Time</div>
                </th>
                <th className="summit-th">
                  <div>Topic</div>
                </th>
              </tr>
              {create_agenda_topics_view2(data?.agenda_topics)}
            </table>
          </div>
        </Container>
      </Container>

      <Container id="board_content" style={{ marginTop: "70px" }}>
        <Row className="title_row">
          <div className="section_header section_header_side">
            <span className="section_header_inner">SPEAKERS</span>
            <div className="section_header_under"></div>
          </div>
        </Row>
        <Row className=" justify-content-center align-items-stretch">
          {create_staff_view(data.speaker, "board_member")}
        </Row>
        <Row className="justify-content-center mt-4">
          <Col md="4">
            <a
              href={data?.agenda_field?.url}
              download
              target="_blank"
              rel="noreferrer"
            >
              <Button
                text={"DOWNLOAD AGENDA"}
                icon={
                  <i
                    style={{ fontSize: "25px" }}
                    class="far fa-arrow-alt-circle-right mt-2"
                  ></i>
                }
              />
            </a>
          </Col>
        </Row>
      </Container>

      <Container
        fluid
        style={{
          backgroundColor: "#F7F7F7",
          paddingTop: "20px",
          paddingBottom: "100px",
          marginTop: "100px",
          marginBottom: "0px",
        }}
      >
        <Container>
          <Row className=" justify-content-center">
            <Col>
              <div class="sub_page_header">
                <span class="sub_page_header_inner">
                  OUR SPONSORS AND PARTNERS
                </span>
                <div className="sub_page_header_under"></div>
              </div>
            </Col>
          </Row>

          <Row className="title_row mt-5">
            <div className="section_header section_header">
              <span className="section_header_inner">GOLD SPONSORS</span>
              <div className="section_header_under"></div>
            </div>
          </Row>
          <Row className=" justify-content-center justify-content-md-center">
            <div
              className="justify-content-center justify-content-md-center"
              style={{
                display: "flex",
                maxWidth: "100%",
                flexWrap: "wrap",
                justifyContent: "center",
                marginBottom: "40px",
                zIndex: "2",
                paddingTop: 0,
              }}
            >
              {generate_sponsors_views(data?.summit_sponsor, "gold")}
            </div>
          </Row>

          <Row className="title_row mt-5">
            <div className="section_header section_header">
              <span className="section_header_inner">
                SUSTAINABILITY PARTNERS
              </span>
              <div className="section_header_under"></div>
            </div>
          </Row>
          <Row className=" justify-content-center justify-content-md-center">
            <div
              className="justify-content-center justify-content-md-center"
              style={{
                display: "flex",
                maxWidth: "100%",
                flexWrap: "wrap",
                justifyContent: "center",
                marginBottom: "0px",
                zIndex: "2",
                paddingTop: 0,
              }}
            >
              {generate_sponsors_views(data?.summit_sponsor, "platinum")}
            </div>
          </Row>

          <Row className="title_row mt-5">
            <div className="section_header section_header">
              <span className="section_header_inner">SILVER SPONSORS</span>
              <div className="section_header_under"></div>
            </div>
          </Row>
          <Row className=" justify-content-center justify-content-md-center">
            <div
              className="justify-content-center justify-content-md-center"
              style={{
                display: "flex",
                maxWidth: "100%",
                flexWrap: "wrap",
                justifyContent: "center",
                marginBottom: "40px",
                zIndex: "2",
                paddingTop: 0,
              }}
            >
              {generate_sponsors_views(data?.summit_sponsor, "silver")}
            </div>
          </Row>
          <Row className="justify-content-center mt-4">
            <Col md="4">
              {/* <Button
                text={"SPONSOR THE EVENT"}
                icon={
                  <i
                    style={{ fontSize: "25px" }}
                    class="far fa-arrow-alt-circle-right mt-2 "
                  ></i>
                }
              /> */}
            </Col>
          </Row>
        </Container>
      </Container>
      {/* <div className="g-section" style={{ display: "flex", marginTop: "0px" }}>
        <div className="g-section-texts">
          <div className="g-section-texts-title">Book your Seat!</div>
          <div className="g-texts-info">
            <div>Hotel Address:</div>
            <div>DUBAI - UAI</div>
          </div>
          <div className="g-texts-info">
            <div>Phone number:</div>
            <div>0114644458589</div>
          </div>
          <div className="g-texts-info">
            <div>Email:</div>
            <div>info@cebcmena.com</div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: "90px",
            }}
          >
            <div
              className="g-button"
              style={{ width: "400px", maxWidth: "90%", margin: "auto" }}
            >
              <Button
                text={"BUY A TICKET!"}
                icon={
                  <i
                    style={{ fontSize: "25px" }}
                    class="far fa-arrow-alt-circle-right mt-2"
                  ></i>
                }
              />
            </div>
          </div>
        </div>
        <div className="g-section-image">
          <img
            src={meeting}
            alt=""
            style={{
              margin: "auto",
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>
      </div> */}
    </div>
  );
}

export default ConsultancyPageComponent;
